import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";
import { Button } from "./ui/button";

/**
 * Lightweight public shell for anon browsing.
 * Used on /grants, /grants/:id, /capital when user is NOT signed in.
 */
const PublicBrowseShell = ({ children }) => {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="public-browse-shell">
      {/* Top bar */}
      <header className="border-b border-zinc-900 sticky top-0 bg-black/95 backdrop-blur z-40">
        <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" data-testid="public-shell-logo">
            <Lightning weight="fill" className="w-6 h-6 text-emerald-500 group-hover:text-emerald-400 transition" />
            <span className="text-lg font-semibold tracking-tight">FlashGrants</span>
          </Link>

          <div className="flex items-center gap-2">
            <Link
              to="/grants"
              className="hidden sm:inline text-sm text-zinc-400 hover:text-white px-3 py-1.5 transition"
              data-testid="public-shell-grants-link"
            >
              Grants
            </Link>
            <Link
              to="/capital"
              className="hidden sm:inline text-sm text-zinc-400 hover:text-white px-3 py-1.5 transition"
              data-testid="public-shell-capital-link"
            >
              Capital
            </Link>
            <Link to="/" data-testid="public-shell-signin-link">
              <Button
                size="sm"
                className="bg-emerald-500 hover:bg-emerald-400 text-black font-semibold text-sm"
              >
                Sign in / Get started
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-6xl mx-auto px-5 py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-900 mt-16">
        <div className="max-w-6xl mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <div>
            &copy; {new Date().getFullYear()} FlashGrants &middot; Built for South Carolina
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="hover:text-white transition">Home</Link>
            <Link to="/pricing" className="hover:text-white transition">Pricing</Link>
            <Link to="/" className="hover:text-white transition">Sign in</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicBrowseShell;
